import Vue from 'vue';

export default {
    logError(error, vs) {
        console.log(error);
        if(error.response.status) {
            vs.notify({
                title: "Oeps!",
                text: '(' + error.response.status + ') ' + error.response.data.message,
                color: "danger",
                fixed: true,
                position: "top-center",
            });
        } else {
            vs.notify({
                title: "Oeps!",
                text: error.response.data.message,
                color: "danger",
                fixed: true,
                position: "top-center",
            });
        }
    },
    notify(title, body, vs) {
        vs.notify({
            time: 8000,
            title: title,
            text: body,
            color: "green",
            position: "top-center",
        });
    },
    loading(element, vs) {
        vs.loading({
            background: 'primary',
            color: '#fff',
            container: element,
            scale: 0.45
        });
    },
    getStaffToken() {
        return JSON.parse(localStorage.getItem("stafftoken"));
    },

    getConfig() {
        return { headers: { Authorization: "Bearer " + this.getStaffToken(), }, };
    }

};
